(function (angular) {
    'use strict';

    angular.module('app.purchase').controller('app.purchase.InviteToPlanController', [
        'app.purchase.purchaseFlowService',
        '$uibModalInstance',
        'ui',
        function (purchaseFlowService, $uibModalInstance, ui) {
            var vm = this;
            vm.sendInvite = sendInvite;
            vm.publicCaptchaKey = environment.publicCaptchaKey;

            function sendInvite() {
                ui.block();
                purchaseFlowService
                    .sendInvitation(vm.phoneNumber, vm.captchaResponse)
                    .then(
                        function success() {
                            ui.unblock();
                            $uibModalInstance.close(true);
                        },
                        function failure() {
                            ui.unblock();
                            $uibModalInstance.close(false);
                        }
                    )
                    .catch(function failure(result) {
                        console.error(result);
                        ui.unblock();
                    });
            }
        }
    ]);
})(angular);
